import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <div className="Footer">
            <a href="https://github.com/raheeeg/weather-react">Open-source code</a> by Raheeg Ibrahim
        </div>
    )
}